import { ref } from 'vue';
import { usePostHog } from '@core/analytics';

const { posthog } = usePostHog();

const isVisible = ref(false);

// The paywall can be closed at once — no forced wait (TONE-OF-VOICE: no pressure).
export function showPaywall(from: string) {
  posthog.capture('paywall_shown', { from });
  isVisible.value = true;
}

export function hidePaywall() {
  isVisible.value = false;
}

export function usePaywall() {
  return {
    isVisible,
    showPaywall,
    hidePaywall,
  };
}
